import { useEffect, useRef } from 'react';

/**
 * Use the latest version of a value, working around any closures.
 *
 * A typical use case is accepting a callback prop that will change on every
 * render due to not being memoized. Using the callback as is will trigger
 * things like useEffect having it as a dependency, which is not desired.
 * Getting the callback via this hook will instead keep it outside the
 * dependency list while still ensuring it's the latest version.
 */
export function useLatest<T>(callback: T) {
	const ref = useRef<T>(callback);

	useEffect(() => {
		ref.current = callback;
	}, [callback]);

	return ref;
}
